<template>
  <div class="home">
        <!-- Spinner Start -->
       <!-- <Spinner/> -->
        <!-- Spinner End -->

        <!-- Hero Start -->
        <ImageSlider></ImageSlider>
        <!-- Hero End -->

        <!-- Courses Start -->
        <Courses></Courses>
        <!-- Courses End -->

        <!-- About Satrt -->
        <AboutView></AboutView>
        <!-- About End -->

        <!-- Events Start -->
        <Event></Event>
        <!-- Events End -->
        
        <!-- Team Start -->
       <!-- <Team></Team> -->
        <!-- Team End -->

        <!-- Testimonial Start -->
       <Testimonial></Testimonial>
        <!-- Testimonial End -->

        <!-- Blog Start -->
        <Blog></Blog>
        <!-- Blog End -->
  </div>
</template>

<script>
import ImageSlider from '../components/ImageSlider.vue';
import AboutView from '../components/About.vue';
import Courses from '../components/Courses.vue';
import Event from '../components/Event.vue';
import Testimonial from '../components/Testimonial.vue';
import Blog from '../components/Blog.vue'

export default {
  name: 'home',
  components: {
    ImageSlider,
    AboutView,
    Courses,
    Event,
    Testimonial,
    Blog
  },
  mounted() {
   
  },
}
</script>
